import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import MODAL from '../../components/modal/modal';
import GoalForm from './goal-form';

export default function GOAL_EDIT_MODAL({ isOpen, onClose, goal, getUserGoals, allGoals }) {
  const [saving, setSaving] = useState(false);
  const close = () => { if (!saving) onClose(); };
  const save = async values => {
    setSaving(true);
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_WEB_URL}api/goals/edit-one-goal`, { ...values, id: goal._id }, { withCredentials: true });
      if (!data.success) throw new Error(data.message || 'Unable to save the goal.');
      if (getUserGoals) await getUserGoals(data.goal);
      toast.success('Goal updated.', { position: 'top-right' });
      onClose();
    } finally { setSaving(false); }
  };

  return <MODAL isOpen={isOpen} onClose={close}>
    <h2>Edit Goal</h2>
    {isOpen && goal && <GoalForm key={goal._id} goal={goal} allGoals={allGoals} onSubmit={save} onCancel={close} />}
  </MODAL>;
}
